export function validateDistributorEmail(existingEmails = [], email, distributor = null) {
  const normalizedEmail = typeof email === 'string' ? email.trim().toLowerCase() : '';

  if (!normalizedEmail) {
    return null;
  }

  const isDuplicate = existingEmails.some((existingEmail) => {
    const normalizedExistingEmail = typeof existingEmail === 'string' ? existingEmail.trim().toLowerCase() : '';
    return normalizedExistingEmail === normalizedEmail && (!distributor || String(distributor.email || '').trim().toLowerCase() !== normalizedEmail);
  });

  return isDuplicate ? 'Distribution account with this email already exists.' : null;
}
